'use strict';

function isHTTPS(protocol) {
  protocol = protocol || global.location.protocol;

  return protocol === 'https:';
}

module.exports = {
  isHTTPS: isHTTPS
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/lib/is-https.js
// module id = 828
// module chunks = 0